//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AddExclusionCategoriesJournalist } from './models/AddExclusionCategoriesJournalist';
import type { ExclusionCategoriesJournalist } from './models/ExclusionCategoriesJournalist';
import { Utilities } from './Utilities';

export class ExclusionCategoriesJournalistClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        add: (): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deleteById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all categories excluded for journalist
     * @return OK
     * @deprecated
     */
    async get(): Promise<ExclusionCategoriesJournalist[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ExclusionCategoriesJournalist[]>(_response, false, []);
    }

    /**
     * Add a new exclusion category for journalist.
     * @param body (optional) An excluded category for journalist to add
     * @return Created
     * @deprecated
     */
    async add(
        body?: AddExclusionCategoriesJournalist,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.add();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Retrieves a category excluded for journalist
     * @param id The exclusion id
     * @return OK
     * @deprecated
     */
    async getById(
        id: number,
    ): Promise<ExclusionCategoriesJournalist> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ExclusionCategoriesJournalist>(_response, false, []);
    }

    /**
     * Delete the specified exclusion category for journalist.
     * @param id The excluded category for journalist Id
     * @deprecated
     */
    async deleteById(
        id: number,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deleteById(
            id,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
